import { Badge, Box, Flex, HStack, Stack, Table, Tbody, Td, Th, Thead, Tr, VStack } from "@chakra-ui/react";
import CDS from "design-system";
import moment from "moment";
import type { PreviewAction } from "../types";
import { groupActionsByRelativeDay } from "../helpers";
import PreviewActionTypeIcon from "./PreviewActionTypeIcon";

interface PreviewListViewProps {
  actions: PreviewAction[];
  startDate: string;
  timezone: string;
}

export default function PreviewListView({ actions, startDate, timezone }: PreviewListViewProps) {
  if (actions.length === 0) {
    return (
      <Box p="6" textAlign="center" color="gray.500">
        No actions to preview yet.
      </Box>
    );
  }

  const groups = groupActionsByRelativeDay(actions, startDate, timezone);

  return (
    <Stack spacing="6">
      {groups.map((group) => (
        <Box key={group.label}>
          <CDS.Text12 fontWeight="semibold" color="gray.600" mb="2">
            {group.label}
          </CDS.Text12>
          <Table size="sm" variant="simple">
            <Thead>
              <Tr>
                <Th width="40px"></Th>
                <Th>Action</Th>
                <Th>When</Th>
                <Th>Path</Th>
              </Tr>
            </Thead>
            <Tbody>
              {group.actions.map((action) => (
                <Tr key={action.previewId}>
                  <Td>
                    <PreviewActionTypeIcon action={action} />
                  </Td>
                  <Td>{action.name}</Td>
                  <Td>
                    {action.isImmediate ? (
                      <Badge colorScheme="purple">Immediate</Badge>
                    ) : (
                      <Flex direction="column">
                        <CDS.Text12>
                          {action.scheduledAt ? moment.tz(action.scheduledAt, timezone).format("h:mm A") : "—"}
                        </CDS.Text12>
                        {action.triggerDescriptor && (
                          <CDS.Text10 color="gray.500">
                            {action.triggerDescriptor}
                          </CDS.Text10>
                        )}
                      </Flex>
                    )}
                  </Td>
                  <Td>
                    <CDS.Text10 color="gray.600">
                      {action.pathName}
                    </CDS.Text10>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      ))}
      <HStack justify="flex-end" pt="2">
        <VStack align="end" spacing="0">
          <CDS.Text10 color="gray.500">
            {actions.length} actions across this journey
          </CDS.Text10>
        </VStack>
      </HStack>
    </Stack>
  );
}
